<template>
  <div>
    <div v-if="channel == 1">Amigos</div>
    <div v-if="channel == 2">Site</div>
    <div v-if="channel == 3">E-mail</div>
    <div v-if="channel == 4">Facebook</div>
    <div v-if="channel == 5">Instagram</div>
    <div v-if="!!channel && ![1,2,3,4,5].includes(channel)">Outros: {{channel}}</div>
  </div>
</template>

<script>
export default {
  name: 'Channel',
  props: {
    channel: String
  }
}
</script>
